var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNearbyLinkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "31px",
    height: "31px",
    viewBox: "0 0 31 31",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L29.3322 0L29.3322 29.3322L0 29.3322L0 0Z",
    transform: "translate(0.7339033 0.7339399)",
    id: "path_1"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "mask_1"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path_1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group-6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L29.3322 0L29.3322 29.3322L0 29.3322L0 0Z",
    transform: "translate(0.7339033 0.7339399)",
    id: "Clip-2",
    fill: "none",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#mask_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 12.6223C0 19.5822 5.66245 25.2446 12.6223 25.2446C19.5822 25.2446 25.2446 19.5822 25.2446 12.6223C25.2446 5.66245 19.5822 0 12.6223 0C5.66245 0 0 5.66245 0 12.6223ZM1.55962 12.6223C1.55962 6.52245 6.52245 1.55962 12.6223 1.55962C18.7222 1.55962 23.685 6.52245 23.685 12.6223C23.685 18.7225 18.7222 23.685 12.6223 23.685C6.52245 23.685 1.55962 18.7225 1.55962 12.6223Z",
    transform: "translate(2.777648 2.777721)",
    id: "Fill-1",
    fill: "#059FF5",
    fillRule: "evenodd",
    stroke: "none"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M8.16051 14.298C8.1752 14.2993 8.18989 14.3 8.20424 14.3C8.39451 14.3 8.56576 14.1865 8.63953 14.0113L14.2625 0.656266C14.3373 0.478681 14.2972 0.275058 14.1614 0.139198C14.0716 0.0497374 13.9524 0 13.8262 0C13.7635 0 13.7027 0.0126847 13.6443 0.0373865L0.289321 5.66038C0.0987169 5.7405 -0.0164468 5.93277 0.00191263 6.13839C0.0202721 6.34402 0.168483 6.51193 0.370103 6.55699L6.25948 7.86585C6.34694 7.88521 6.41537 7.95331 6.43473 8.0411L7.74292 13.9301C7.78798 14.1318 7.95622 14.2793 8.16051 14.298ZM12.4206 1.57758C12.4493 1.56523 12.48 1.55922 12.51 1.55922C12.5701 1.55922 12.6289 1.58258 12.6733 1.62698C12.7394 1.69307 12.7591 1.79322 12.7227 1.87967L8.62484 11.6122C8.58845 11.6983 8.50434 11.7534 8.4122 11.7534C8.40553 11.7534 8.39852 11.753 8.39151 11.7524C8.29137 11.7437 8.20892 11.6709 8.18688 11.5728L7.25957 7.39985C7.21984 7.22127 7.07864 7.0804 6.90072 7.04068L2.72712 6.11336C2.62898 6.09133 2.55655 6.00854 2.54753 5.90873C2.53852 5.80859 2.59527 5.71412 2.68773 5.6754L12.4206 1.57758Z",
    transform: "translate(7.092079 9.407824)",
    id: "Fill-4",
    fill: "#FFFFFF",
    fillRule: "evenodd",
    stroke: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNearbyLinkIcon);
export default __webpack_public_path__ + "static/media/nearby-link-icon.afc997d432353ac4e0fcaabc4df683db.svg";
export { ForwardRef as ReactComponent };